export {
  FilterChipSelect as PeopleFilterChipSelect
} from 'Src/components/FilterChipSelect/FilterChipSelect';

export type {
  FilterChipOption as PeopleFilterChipOption
} from 'Src/components/FilterChipSelect/FilterChipSelect';
